import { ResourceItem } from "./resources/ResourceItem";
import { Resource } from "./resource";

export interface UpdateActions<TDetail extends ResourceItem> {
  updateItem(item: TDetail): Promise<TDetail>;
}
export type UpdateResource<TDetail extends ResourceItem = any> = Resource<
  UpdateActions<TDetail>
>;

export function createUpdateResource<TDetail extends ResourceItem>(
  apiUrl: string,
  dataTransform: (data: any) => TDetail,
): UpdateResource<TDetail> {
  return (client) => ({
    async updateItem(item) {
      const data = item.getPostData();
      const resp = await client.put(`${apiUrl}${item.id}/`, data);

      return dataTransform(resp.data);
    },
  });
}
